import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33bf8285"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "paymentMethodDetailForm",
  class: "card mb-5 mx-auto"
}
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = {
  class: "card-title d-flex align-item-center justify-content-between",
  style: {"width":"100%"}
}
const _hoisted_4 = { class: "d-flex align-item-center nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-3 fw-semobold" }
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_9 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Active", -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  colspan: "9",
  class: "fw-semibold pt-7 pb-0"
}
const _hoisted_14 = { class: "d-flex justify-content-between" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "p-0" }
const _hoisted_17 = { class: "form-check form-switch form-switch-sm form-check-custom form-check-solid" }
const _hoisted_18 = ["checked"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-semobold text-muted" }, null, -1))
const _hoisted_20 = { class: "p-0" }
const _hoisted_21 = {
  key: 0,
  class: "d-flex justify-content-end me-11"
}

import { ElNotification } from "element-plus";
import { ref, onMounted, inject } from "vue";
import PaymentService from "@/projects/tenant/modules/Payment/services/PaymentService";
import AccountInjectionKeys from "@/projects/tenant/modules/accounts/types/AccountInjectionKeys";


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentMethodDetailForm',
  props: {
  openForm: { type: Boolean, required: false, default: false },
},
  emits: ["submit"],
  setup(__props, { emit: emits }) {

const props = __props;

const isLoading = ref(true);
const isSubmitting = ref(false);
const deposit = ref({} as any);
const hideActive = ref(true);
const currTab = ref("Deposit");
const withdraw = ref({} as any);
const accountPaymentMethods = ref({} as any);
const accountPaymentServices = ref(Array<any>() as any);
const accountDetails = inject<any>(AccountInjectionKeys.ACCOUNT_DETAILS);





const enableGroupAll = async (group: string) => {
  isSubmitting.value = true;
  try {
    await PaymentService.putEnableAccountPaymentMethodByGroup(
      group,
      accountDetails.value.id
    );
    accountPaymentServices.value[group].forEach((item: any) => {
      item.accessStatus = 10;
    });
    ElNotification({
      title: group,
      message: "All Deposit enabled successfully",
      type: "success",
    });
    // fetchData();
  } catch (e) {
    ElNotification.error({
      title: "Error",
      message: "Error Submit",
      type: "error",
    });
    console.error(e);
  } finally {
    isSubmitting.value = false;
  }
};

const disableGroupAll = async (group: string) => {
  isSubmitting.value = true;
  try {
    await PaymentService.putDisableAccountPaymentMethodByGroup(
      group,
      accountDetails.value.id
    );
    accountPaymentServices.value[group].forEach((item: any) => {
      item.accessStatus = 0;
    });
    ElNotification({
      title: group,
      message: "All Deposit disabled successfully",
      type: "success",
    });
    // fetchData();
  } catch (e) {
    ElNotification.error({
      title: "Error",
      message: "Error Submit",
      type: "error",
    });
    console.error(e);
  } finally {
    isSubmitting.value = false;
  }
};

const paymentMethodChanged = async (_item: any) => {
  try {
    if (_item.accessStatus) {
      await PaymentService.putEnableAccountPaymentMethodById(
        _item.id,
        accountDetails.value.id
      );
    } else {
      await PaymentService.putDisableAccountPaymentMethodById(
        _item.id,
        accountDetails.value.id
      );
    }

    ElNotification({
      title: _item.name,
      message: "Payment method updated successfully",
      type: "success",
    });
  } catch (e) {
    ElNotification.error({
      title: "Error",
      message: "Error Submit",
      type: "error",
    });
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};

const changeTab = (tab: string) => {
  currTab.value = tab;
  hideActive.value = true;

  if (tab === "Deposit") {
    accountPaymentServices.value = deposit.value;
  } else {
    accountPaymentServices.value = withdraw.value;
  }

  hideShowActive();
};

const fetchData = async () => {
  isLoading.value = true;
  try {
    accountPaymentMethods.value =
      await PaymentService.getAccountPaymentMethodById(accountDetails.value.id);

    var tempDeposit = accountPaymentMethods.value.deposit;
    tempDeposit = tempDeposit.reduce((index, item) => {
      if (index[item.group]) {
        index[item.group].push(item);
      } else {
        index[item.group] = [item];
      }
      return index;
    }, {});
    Object.keys(tempDeposit)
      .sort()
      .forEach((group) => {
        deposit.value[group] = tempDeposit[group];
      });

    var tempwithdrawal = accountPaymentMethods.value.withdrawal;
    tempwithdrawal = tempwithdrawal.reduce((index, item) => {
      if (index[item.group]) {
        index[item.group].push(item);
      } else {
        index[item.group] = [item];
      }
      return index;
    }, {});

    Object.keys(tempwithdrawal)
      .sort()
      .forEach((group) => {
        withdraw.value[group] = tempwithdrawal[group];
      });

    if (currTab.value === "Deposit") {
      accountPaymentServices.value = deposit.value;
    } else {
      accountPaymentServices.value = withdraw.value;
    }

    isLoading.value = false;
  } catch (error) {
    console.log(error);
  }
};

const hideShowActive = () => {
  if (hideActive.value) {
    accountPaymentServices.value = Object.keys(accountPaymentServices.value)
      .filter((group) => {
        return accountPaymentServices.value[group].some((item) => {
          return item.status == 10;
        });
      })
      .reduce((index, group) => {
        index[group] = accountPaymentServices.value[group].filter((item) => {
          return item.status == 10;
        });
        return index;
      }, {});
  } else {
    fetchData();
  }
};

// watch(hideActive, (value) => {
//   if (value) {
//     accountPaymentServices.value = Object.keys(accountPaymentServices.value)
//       .filter((group) => {
//         return accountPaymentServices.value[group].some((item) => {
//           return item.status == 10;
//         });
//       })
//       .reduce((index, group) => {
//         index[group] = accountPaymentServices.value[group].filter((item) => {
//           return item.status == 10;
//         });
//         return index;
//       }, {});
//   } else {
//     fetchData();
//   }
// });

const submitForm = () => {
  emits("submit");
};

onMounted(async () => {
  await fetchData();
  hideShowActive();
  isLoading.value = false;
});

return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("ul", _hoisted_4, [
            _createElementVNode("li", _hoisted_5, [
              _createElementVNode("a", {
                class: _normalizeClass([
                  'nav-link text-active-primary pb-1',
                  { active: currTab.value === 'Deposit' },
                ]),
                "data-bs-toggle": "tab",
                href: "#",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (changeTab('Deposit')))
              }, "Deposit", 2)
            ]),
            _createElementVNode("li", _hoisted_6, [
              _createElementVNode("a", {
                class: _normalizeClass([
                  'nav-link text-active-primary pb-1',
                  { active: currTab.value === 'Withdraw' },
                ]),
                "data-bs-toggle": "tab",
                href: "#",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (changeTab('Withdraw')))
              }, "Withdraw", 2)
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_switch, {
            modelValue: hideActive.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((hideActive).value = $event)),
            "active-text": "Show Active Only",
            "inactive-text": "Show All",
            "inactive-color": "#13ce66",
            class: "me-5",
            disabled: isLoading.value,
            onChange: hideShowActive
          }, null, 8, ["modelValue", "disabled"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("table", _hoisted_8, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_9, [
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.name")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.serviceActive")), 1),
            _hoisted_10
          ])
        ]),
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_11, [
              _createVNode(_component_LoadingRing)
            ]))
          : (!isLoading.value && accountPaymentServices.value.length === 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
                _createVNode(_component_NoDataBox)
              ]))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(accountPaymentServices.value, (value, key) => {
                return (_openBlock(), _createElementBlock("tbody", {
                  key: key,
                  class: "fw-semibold tbodyBorder"
                }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("h4", null, _toDisplayString(key), 1),
                        _createElementVNode("div", null, [
                          _createVNode(_component_el_button, {
                            type: "success",
                            onClick: ($event: any) => (enableGroupAll(String(key))),
                            disabled: isLoading.value || isSubmitting.value,
                            size: "small"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Enable All ")
                            ]),
                            _: 2
                          }, 1032, ["onClick", "disabled"]),
                          _createVNode(_component_el_button, {
                            type: "danger",
                            onClick: ($event: any) => (disableGroupAll(String(key))),
                            disabled: isLoading.value || isSubmitting.value,
                            size: "small"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Disable All ")
                            ]),
                            _: 2
                          }, 1032, ["onClick", "disabled"])
                        ])
                      ])
                    ])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_15, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["p-3", item.status ? '' : 'bg-warning rounded'])
                        }, _toDisplayString(item.name) + " " + _toDisplayString(item.id), 3)
                      ]),
                      _createElementVNode("td", _hoisted_16, [
                        _createElementVNode("label", _hoisted_17, [
                          _createElementVNode("input", {
                            class: "form-check-input center-switch",
                            name: "activate",
                            type: "checkbox",
                            checked: item.status,
                            disabled: true
                          }, null, 8, _hoisted_18),
                          _hoisted_19
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_20, [
                        _createVNode(_component_el_switch, {
                          modelValue: item.accessStatus,
                          "onUpdate:modelValue": ($event: any) => ((item.accessStatus) = $event),
                          "active-value": 10,
                          "inactive-value": 0,
                          class: "me-5",
                          disabled: isLoading.value,
                          onChange: ($event: any) => (paymentMethodChanged(item))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"])
                      ])
                    ]))
                  }), 128))
                ]))
              }), 128))
      ])
    ]),
    (props.openForm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: submitForm
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Submit")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})